import React, { useEffect, useState } from "react";
import { HeaderComponent } from "../Config/header";
import { FooterComponent } from "../Config/footer";
import Pagination from "../Config/Pagination";
import { API_BASE_URL } from "../Config/Config";

const Notifications = () => {
  const [storedUserData, setStoredUserData] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const [notif, setNotif] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);

  useEffect(() => {
    const userDataString =
      localStorage.getItem("userData") || sessionStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setStoredUserData(userData);
    } else {
      console.log("User data not found");
    }
  }, []);
  console.log(storedUserData.SuperId, storedUserData.RegId);
  useEffect(() => {
    const fetchData = async () => {
      setDataLoading(true);
      try {
        const response = await fetch(
          `${API_BASE_URL}notification/getNotification?superid=${storedUserData.SuperId}&regid=${storedUserData?.RegId}`,
          {
            method: "GET",
            headers: { Authorization: `Bearer ${storedUserData?.Token}` },
          }
        );
        if (response.ok) {
          const data = await response.json();
          setNotif(data.ResultData); // Store the ResultData array from the response
        } else {
          console.error("Failed to fetch notifications:", response.statusText);
        }
      } catch (error) {
        console.error("Error fetching notifications:", error.message);
      } finally {
        setDataLoading(false);
      }
    };

    fetchData();
  }, [storedUserData]);
  console.log(notif, "notiiii");
  const currentItems = notif.slice(indexOfFirstItem, indexOfLastItem);

  function splitDateTime(dateTimeString) {
    if (!dateTimeString) return { date: "", time: "" };

    const dateObj = new Date(dateTimeString);
    if (isNaN(dateObj)) return { date: "", time: "" };

    // Format date (DD-MM-YYYY)
    const yyyy = dateObj.getFullYear();
    const mm = String(dateObj.getMonth() + 1).padStart(2, "0");
    const dd = String(dateObj.getDate()).padStart(2, "0");
    const formattedDate = `${dd}-${mm}-${yyyy}`;

    // Format time (24-hour)
    const hours = String(dateObj.getHours()).padStart(2, "0");
    const minutes = String(dateObj.getMinutes()).padStart(2, "0");
    const formattedTime = `${hours}:${minutes}`;

    return { date: formattedDate, time: formattedTime };
  }

  return (
    <>
      <HeaderComponent></HeaderComponent>
      <h1 className="my-5 text-start mx-5">
        <i className="fa-solid fa-envelopes-bulk text-primary fs-3x mx-2"></i>
        Notifications
      </h1>
      <div className=" " style={{ marginBottom: "90px" }}>
        <div className="container ">
          {dataLoading ? (
            <p>Loading...</p>
          ) : (
            <>
              {currentItems.map((item, index) => {
                const { date, time } = item?.CreatedOn
                  ? splitDateTime(item?.CreatedOn)
                  : { date: "N/A", time: "" };

                return (
                  <div key={index} className="card m-3 my-4 p-3">
                    <div className="card-title d-flex justify-content-around p-3 align-items-center">
                      <i className="fa-solid fa-envelope fs-3x"></i>
                      <div>Type:{item.Name}</div>
                      <div className="d-flex justify-content-between">
                        <div>{date}, </div>
                        {time && <div>{time}</div>}
                      </div>
                    </div>
                    <div className="card-body p-0 pb-3">
                      Description:{item.Description}
                    </div>
                  </div>
                );
              })}
            </>
          )}
        </div>
        <Pagination
          itemsPerPage={itemsPerPage}
          totalItems={notif.length}
          paginate={paginate}
          currentPage={currentPage}
        />
      </div>
      <FooterComponent></FooterComponent>
    </>
  );
};

export default Notifications;
